import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Program } from '../../programs/types/program.model';
import { SharedService } from '../shared.service';

@Component({
  selector: 'mmb-web-app-program-org-summary-info',
  templateUrl: './program-org-summary-info.component.html',
  styleUrls: ['./program-org-summary-info.component.scss']
})
export class ProgramOrgSummaryInfoComponent implements OnInit {
  @Input() slug: string;
  @Input() program: any;
  @Input() image: string;
  @Input() name: string;
  @Input() professionalTitle: string;
  @Input() company: string;
  @Input() type: string;
  @Input() createdOnDate: Date;
  @Input() id: number;
  @Input() isUser: boolean;
  @Input() popoverSummary: string;
  @Input() userUrl: string;
  @Input() orgUrl: string;
  @Input() redirect: string;
  @Input() location: string;
  @Input() isSaved: boolean;
  @Input() isActionsEnabled: boolean = true;

  @Output() bookmark: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() removeBookmark: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private sharedService: SharedService) { }

  ngOnInit() {
  }

  /**
   * Time left
   */
  getTimeLeft(): { duration: number, type: string } {
    return this.sharedService.getTimeLeft(this.program.deadline_date);

  }
  
  /**
   * Add bookmark
   */
  onBookmark(ev: any) {
    this.bookmark.emit();
    ev.stopPropagation();
  }
  
  getShareUrl() {
    return `${window.location.href}/${this.redirect}`;
  }
  /**
   * Remove bookmark
   */
  onRemoveBookmark(ev: any) {
    this.removeBookmark.emit();
    ev.stopPropagation();
  }

}
